import _styled from '@emotion/styled/base';
import { Input } from '../forms/Input/index.js';
import { InputWrapper } from '../forms/Input/styles.js';
import { Spacing } from '../primitives/spacing.js';
import { border } from '@hubble/tokens/web';

const StyledInput = _styled(Input, {
  target: "e16zac5l1"
})("width:", ({
  width
}) => width ? width : '240px', ";", InputWrapper, "{color:", ({
  disabled,
  theme
}) => disabled ? theme.colorScheme.content.disabled : theme.colorScheme.content.primary, ";border-radius:", border.radius.full, ";overflow:hidden;padding-left:", Spacing.scale[1], ";padding-right:", Spacing.scale[1], ";", ({
  theme,
  disabled,
  variant
}) => variant === 'filled' ? `
    background: ${disabled ? theme.colorScheme.search.background.disabled : theme.colorScheme.search.background.enabled};
    border-color: transparent;
    &:hover { 
      background: ${theme.colorScheme.search.background.hover};
      border-color: transparent;
    };
    &:focus { 
      background: ${theme.colorScheme.search.background.focus};
    };
    input { background: none; };
    ` : '', ";svg{color:inherit!important;}}");
const ClearButton = _styled("button", {
  target: "e16zac5l0"
})("-webkit-appearance:none;border-radius:0;text-align:inherit;background:none;box-shadow:none;padding:0;cursor:pointer;border:none;font:inherit;outline:none;cursor:pointer;line-height:0;color:", ({
  theme
}) => theme.colorScheme.content.secondary, ";&:hover,&:focus{color:", ({
  theme
}) => theme.colorScheme.content.primary, ";}&:disabled{color:", ({
  theme
}) => theme.colorScheme.content.disabled, ";}svg{color:inherit!important;}");

export { ClearButton, StyledInput };
